import { ProductTransferType } from "../types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all product transfers
export const getProductTransfers = async (branch_id?: string | number) => {
  const url = branch_id
    ? `${ServiceEndpoints.PRODUCT_TRANSFER}?branch_id=${branch_id}`
    : ServiceEndpoints.PRODUCT_TRANSFER;

  return axios
    .get(url)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new product transfer
export const createProductTransfer = async (data: FormData) => {
  return axios
    .post(ServiceEndpoints.PRODUCT_TRANSFER, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update a product transfer by ID
export const updateProductTransfer = async (
  id: string,
  data: ProductTransferType
) => {
  const { ...productTransferData } = data;

  return axios
    .put(`${ServiceEndpoints.PRODUCT_TRANSFER}/${id}`, productTransferData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get a product transfer by its ID
export const getProductTransferById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.PRODUCT_TRANSFER}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update a weighbill status by ID
export const updateProductTransferStatus = async (
  id: string,
  data: { status: string }
) => {
  const { ...transferData } = data;

  return axios
    .patch(
      `${ServiceEndpoints.PRODUCT_TRANSFER}/${id}/status?status=${transferData.status}`
    )
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete a product transfer by ID
export const deleteProductTransfer = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.PRODUCT_TRANSFER}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
